import { Container, Label } from "./style";

export const HighlightBtn = ({ label, onClick, active }) => {
  return (
    <Container active={active} onClick={onClick}>
      <Label active={active}>{label}</Label>
    </Container>
  );
};
